export default __webpack_public_path__ + "static/media/daytime-thunderstorm.e4a51e4f.jpg";